import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Layout from "@components/shared/layout";
import MenuLateralUsuarioConsultaPs from "@components/menu_lateral_usuario_consulta_ps";
import FormAutorizacao from "@components/consulta_pronto_socorro/form_autorizacao";
import AreaResultadoAutorizacao from "@components/consulta_pronto_socorro/area_resultado_autorizacao";
import {
  getPrestador,
  requireBiometrics,
  updatePrestador,
  saveBiometrics,
  clearBiometrics,
} from "@store/actions/index";
import m from "@utils/strings";
import _ from "lodash";
import ValidatePrestadorLoader from "@components/shared/ValidatePrestadorLoader";
import BiometricsModal from "@components/BiometricsModal";
import Snackbar from "@components/shared/custom_snackbar";

const WILL_AUTHORIZE = true;

class ConsultaProntoSocorro extends Component {
  click;
  constructor(props) {
    super(props);

    this.state = {
      dataAutorizacao: "",
      snackbarMsg: "",
      snackbarType: "success",
      msgErrorApi: "",
      apiError: false
    };
    // this.handleAuthorizationFormSubmit = this.handleAuthorizationFormSubmit.bind(this);
  }

  dataAutorizacao = (data) => {
    this.setState({ dataAutorizacao: data });
  };

  handleAuthorizationFormSubmit = (error, result = null) => {
    if (error) {
      this.openSnackbar(error, "error");
      return;
    }
    const {
      data: { Biometria },
    } = result;
    if (Biometria?.Utiliza) {
      this.props.requireBiometrics();
      return;
    }
  }

  handleBiometricsResponse = (data) => {
    if (data.response == 400) {
      this.openSnackbar(data.message, "error");
      this.props.clearBiometrics();
      return;
    }
    this.openSnackbar(data.message, "success");
    this.props.clearBiometrics();
  }

  openSnackbar(message, type = "success") {
    this.setState({ snackbarMsg: message, snackbarType: type });
    this.click(); 
  }

  setMsgErrorApi = (msgErro) => {
    this.setState({
      msgErrorApi: msgErro,
      apiError: true
    });
  }

  resetAllStates = () => {
    this.setState({
      apiError: false,
      msgErrorApi: "",
      dataAutorizacao: ""
    });
  }

  render() {
    const { user, beneficiario, prestador } = this.props;

    return (
      <div>
        <ValidatePrestadorLoader />
        <Layout
          user={user}
          iconePath="../images/consulta_ps.png"
          alt={m.TELA_CONSULTA_PRONTO_SOCORRO.TITULO_PAGINA}
          content={m.TELA_CONSULTA_PRONTO_SOCORRO.TITULO_PAGINA}
        />
        <MenuLateralUsuarioConsultaPs
          beneficiario={beneficiario}
          dataAutorizacao={this.state.dataAutorizacao}
        />
        <FormAutorizacao
          onSubmit={this.handleAuthorizationFormSubmit}
          setInitialFieldsState={(e) => (this.resetFormFieldsStates = e)}
          willAuthorize={WILL_AUTHORIZE}
          user={user}
          beneficiario={beneficiario}
          prestador={prestador}
          dataAutorizacao={this.dataAutorizacao}
          setMsgErrorApi={this.setMsgErrorApi}
          resetAllStates={this.resetAllStates}
        />
        <AreaResultadoAutorizacao
          setInitialFieldsState={() => this.resetFormFieldsStates()}
          beneficiario={beneficiario}
          msgErrorApi={this.state.msgErrorApi}
          apiError={this.state.apiError}
          resetAllStates={this.resetAllStates}
        />
        <BiometricsModal
          url={this.props.beneficiario?.data?.Biometria?.Url}
          onBiometryResponse={this.handleBiometricsResponse}
          onClose={this.resetAllStates}
        />
        <Snackbar
          setClick={(clickEvent) => (this.click = clickEvent)}
          variant={this.state.snackbarType}
          duration={6000}
          content={this.state.snackbarMsg}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.oidc.user,
    beneficiario: state.beneficiario,
    prestador: state.prestador,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPrestador,
      updatePrestador,
      requireBiometrics,
      saveBiometrics,
      clearBiometrics,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConsultaProntoSocorro);
